export default __webpack_public_path__ + "static/media/AdfEnvironment.2a1ed5d5.svg";